export default __webpack_public_path__ + "static/media/upload-icon.8d48c14f.svg";